/**
 * Compares two version strings in the format 'x.y.z' (major.minor.patch).
 * This version assumes that the version strings contain only numbers.
 *
 * @param {string} version1 - The first version string to compare.
 * @param {string} version2 - The second version string to compare.
 * @returns {number} -1 if version1 < version2, 1 if version1 > version2, 0 if they are equal.
 *
 * @example
 * compareVersions('1.2.3', '1.2.4'); // returns -1
 * compareVersions('1.3.0', '1.2.9'); // returns 1
 * compareVersions('1.2.3', '1.2.3'); // returns 0
 * compareVersions('1.2', '1.2.3');   // returns -1 (version1 is shorter)
 * compareVersions('1.2.3', '1.2');   // returns 1
 */
export function compareVersions(version1: string, version2: string): number {
  const parts1 = version1.split('.').map(Number);
  const parts2 = version2.split('.').map(Number);
  const maxLength = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < maxLength; i++) {
    const val1 = parts1[i] ?? 0;
    const val2 = parts2[i] ?? 0;

    if (val1 < val2) return -1;
    if (val1 > val2) return 1;
  }

  return 0;
}
